/*
 * @Author: Nora Galvin
 * @Date: 2020-08-28 17:14:43
 * @Last Modified by: Nora
 * @Last Modified time: 2020-08-28 17:50:13
 */

import type { TypePopUpOptions } from './type';
/**
 * Popup sidebar template
 * @param options ..
 * @returns string
 */
export default (options: TypePopUpOptions): string => {
  return `
  <div class="sidebar-popup">
    <div class="cancel">
      <span>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0.59467 0.59467C0.887563 0.301777 1.36244 0.301777 1.65533 0.59467L11.6553 10.5947C11.9482 10.8876 11.9482 11.3624 11.6553 11.6553C11.3624 11.9482 10.8876 11.9482 10.5947 11.6553L0.59467 1.65533C0.301777 1.36244 0.301777 0.887563 0.59467 0.59467Z" fill="#D6D6D6"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.4053 0.34467C11.6982 0.637563 11.6982 1.11244 11.4053 1.40533L1.40533 11.4053C1.11244 11.6982 0.637563 11.6982 0.344671 11.4053C0.0517774 11.1124 0.0517774 10.6376 0.344671 10.3447L10.3447 0.34467C10.6376 0.0517767 11.1124 0.0517766 11.4053 0.34467Z" fill="#D6D6D6"/>
        </svg>
      </span>
    </div>
    <div class="popup-body">
      <div class="popup-title">
        <p>${options.title}</p>
      </div>
      <div class="popup-description">
        <p>${options.description}</p>
      </div>

      <div class="buttons-group">
        <button data-button="primary" class="gf_btn ${options.primaryButton.class}">${options.primaryButton.text}</button>
        <button data-button="secondary" class="gf_btn ${options.secondaryButton.class}">${options.secondaryButton.text}</button>
      </div>
    </div>
  </div>
  `;
};
